module.exports = __webpack_public_path__ + "static/media/cricket-world-cup.bd690234.png";